import { Fragment, useEffect, useState, type ComponentType } from "react";

type OpenClickyBridgeComponent = ComponentType<Record<string, never>>;
type BridgePair = {
  OpenClickyBridge: OpenClickyBridgeComponent;
  ConsulControlBridge: OpenClickyBridgeComponent;
};

export function LazyOpenClickyBridge() {
  const [bridges, setBridges] = useState<BridgePair | null>(null);

  useEffect(() => {
    let cancelled = false;
    let timeoutId: number | null = null;

    const loadBridge = () => {
      timeoutId = window.setTimeout(() => {
        Promise.all([
          import("./OpenClickyBridge"),
          import("../consul-control/ConsulControlBridge"),
        ]).then(([openClicky, consul]) => {
          if (cancelled) return;
          setBridges({
            OpenClickyBridge: openClicky.OpenClickyBridge,
            ConsulControlBridge: consul.ConsulControlBridge,
          });
        });
      }, 0);
    };

    if (document.readyState === "complete") loadBridge();
    else window.addEventListener("load", loadBridge, { once: true });

    return () => {
      cancelled = true;
      if (timeoutId !== null) window.clearTimeout(timeoutId);
      window.removeEventListener("load", loadBridge);
    };
  }, []);

  if (!bridges) return null;
  const OpenClickyBridge = bridges.OpenClickyBridge;
  const ConsulControlBridge = bridges.ConsulControlBridge;
  return (
    <Fragment>
      <OpenClickyBridge />
      <ConsulControlBridge />
    </Fragment>
  );
}
